import { configureStore} from "@reduxjs/toolkit";
import { createReduxHistoryContext } from "redux-first-history";
import { composeWithDevTools } from "@redux-devtools/extension";
import { createHashHistory } from "history";

// reducers
import settings from "../reducers/settings";
import appdata from "../reducers/appdata/appdata"
import vendordata from "../reducers/vendordata/vendordata"
import overviewdata from "reducers/overview/overviewdata";

// https://github.com/salvoravida/redux-first-history

const { createReduxHistory, routerReducer } = createReduxHistoryContext({
  history: createHashHistory()
});

const reducer = {
  router: routerReducer,
  settings: settings,
  appdata:appdata,
  vendordata:vendordata,
  overviewdata:overviewdata
};

export const store = configureStore({
  reducer: reducer,
  enhancer: [composeWithDevTools()]
});

export const history = createReduxHistory(store);
